import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { AdProviders, adunitMemo, ADUNIT_MAP } from '../../../constants';
import { useAdUnit } from '../../../useAdUnit';
const DesktopDevPageArtStage = /*#__PURE__*/ React.memo(({ safety = 'off', safetyState })=>{
    const _useAdUnit = useAdUnit(AdProviders.Primis, ADUNIT_MAP['DesktopDevPageArtStageVideo'], safety, safetyState, {
        placementId: 114276,
        vpContent: 'plembed35b9omrwtkip',
        verticalOffset: 98,
        clientOnly: true,
        floatDirection: 'bl',
        floatWidth: 300
    }), { advertIsOff } = _useAdUnit, slotAttr = _object_without_properties(_useAdUnit, [
        "advertIsOff"
    ]);
    if (advertIsOff === 'off') {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", _object_spread({
        style: {
            aspectRatio: '16/9'
        }
    }, slotAttr));
}, adunitMemo);
DesktopDevPageArtStage.displayName = 'DesktopDevPageArtStage';
export default DesktopDevPageArtStage;
